import { useCallback } from 'react';

import { SupplierStatus } from './SupplierStatus';

export interface SupplierListItemProps {
    isVerticallyAligned: boolean;
    status: SupplierStatus;
    disabled: boolean;
    statusUpdater: (SupplierStatus) => void;
    suffix: string;
}

export default function SupplierListItem(props: SupplierListItemProps) {
    const onClick = useCallback(
        e => {
            props.statusUpdater({ supplier: props.status.supplier, checked: e.target.checked });
        },
        [props]
    );

    const supplierID = `${props.status.supplier.id}${props.suffix}`;

    function renderCheckbox() {
        return (
            <>
                <input
                    type="checkbox"
                    id={supplierID}
                    checked={props.status.checked}
                    onChange={onClick}
                    disabled={props.disabled}
                />
                <label className="font-300" htmlFor={supplierID}>
                    <span>{props.status.supplier.name}</span>
                </label>
            </>
        );
    }

    return props.isVerticallyAligned ? (
        <div className="checkbox-tick font-4" key={supplierID}>
            {renderCheckbox()}
        </div>
    ) : (
        <li key={supplierID}>
            <div className="checkbox-tick font-4">{renderCheckbox()}</div>
        </li>
    );
}
